import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import dashboard from "../../assests/images/navDashboard.svg";
import dashboardDark from "../../assests/images/navDashboardDark.svg";
import token from "../../assests/images/navToken.svg";
import tokenDark from "../../assests/images/navTokenDark.svg";
import upload from "../../assests/images/navUpload.svg";
import uploadDark from "../../assests/images/navUploadDark.svg";
import runisort from "../../assests/images/navRunisort.svg";
import runisortDark from "../../assests/images/navRunisortDark.svg";
import result from "../../assests/images/navResult.svg";
import resultDark from "../../assests/images/navResultDark.svg";
import tutorial from "../../assests/images/navTutorial.svg";
import tutorialDark from "../../assests/images/navTutorialDark.svg";
import runlocally from "../../assests/images/navRunLocally.svg";
import runlocallyDark from "../../assests/images/navRunLocallyDark.svg";
import references from "../../assests/images/navReference.svg";
import referencesDark from "../../assests/images/navReferenceDark.svg";
import setting from "../../assests/images/navSettings.svg";
import settingDark from "../../assests/images/navSettingsDark.svg";
import signout from "../../assests/images/navSignOut.svg";
import { useAuth } from "../../api/authUtils/AuthContext";
import ErrorPopUp from "./ErrorPopUp";
import { logoutUser } from "../../api/authUtils/helper/auth";
import { useNavigate } from "react-router-dom";
export default function NavbarMenu() {
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const show = { display: "block" };
  const hide = { display: "none" };
  const navigate = useNavigate();

  const handleLogout = async () => {
    const success = await logoutUser();
    if (success) {
      setUser(null); // clear user context
      navigate("/login", {
        state: { message: "Logged out successfully." },
      }); // redirect to login
    } else {
      setError("User Logout Unsuccessful");
    }
  };
  return (
    <>
      {error && (
        <ErrorPopUp
          show={true}
          onClose={() => setError(null)}
          heading="Logout Error"
          text={error}
        />
      )}
      <div className="navbar-menu-wrapper">
        <div className="navbar-menu">
          <div style={{ paddingBottom: "16px" }}>
            <p className=" navbar-heading text-white">Main Menu</p>
            <ul className="nav flex-column mb-auto nav-pills">
              <li>
                <Link
                  to="/dashboard"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/dashboard" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={dashboardDark}
                    alt=""
                    style={location.pathname === "/dashboard" ? show : hide}
                  />
                  <img
                    src={dashboard}
                    alt=""
                    style={location.pathname === "/dashboard" ? hide : show}
                  />
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/tokens"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/tokens" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={tokenDark}
                    alt=""
                    style={location.pathname === "/tokens" ? show : hide}
                  />
                  <img
                    src={token}
                    alt=""
                    style={location.pathname === "/tokens" ? hide : show}
                  />
                  Tokens
                </Link>
              </li>
              <li>
                <Link
                  to="/uploadfile"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/uploadfile" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={uploadDark}
                    alt=""
                    style={location.pathname === "/uploadfile" ? show : hide}
                  />
                  <img
                    src={upload}
                    alt=""
                    style={location.pathname === "/uploadfile" ? hide : show}
                  />
                  Upload Files
                </Link>
              </li>
              <li>
                <Link
                  to="/runisort"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/runisort" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={runisortDark}
                    alt=""
                    style={location.pathname === "/runisort" ? show : hide}
                  />
                  <img
                    src={runisort}
                    alt=""
                    style={location.pathname === "/runisort" ? hide : show}
                  />
                  Run iSort&trade; on Browser
                </Link>
              </li>
              <li>
                <Link
                  to="/results"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/results" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={resultDark}
                    alt=""
                    style={location.pathname === "/results" ? show : hide}
                  />
                  <img
                    src={result}
                    alt=""
                    style={location.pathname === "/results" ? hide : show}
                  />
                  Results
                </Link>
              </li>
            </ul>
            <p
              className="navbar-heading text-white"
              style={{ margin: "13px 0 6px 0" }}
            >
              Resources
            </p>
            <ul className="nav nav-pills flex-column mb-auto">
              <li>
                <Link
                  to="/tutorials"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/tutorials" ? "active-custom" : ""
                  }`}
                >
                  <img
                    src={tutorialDark}
                    alt=""
                    style={location.pathname === "/tutorials" ? show : hide}
                  />
                  <img
                    src={tutorial}
                    alt=""
                    style={location.pathname === "/tutorials" ? hide : show}
                  />
                  Tutorials
                </Link>
              </li>
              <li>
                <Link
                  to="/runlocally"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/runlocally" ? "active-custom" : ""
                  }`}
                >
                  <img
                src={runlocallyDark}
                alt=""
                style={location.pathname === "/runlocally" ? show:hide}
              />
              <img
                src={runlocally}
                alt=""
                style={location.pathname === "/runlocally" ? hide:show}
              />
                
                  Run iSort&trade; Locally
                </Link>
              </li>
              <li>
                <Link
                  to="/references"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/references" ? "active-custom" : ""
                  }`}
                ><img
                src={referencesDark}
                alt=""
                style={location.pathname === "/references" ? show:hide}
              />
              <img
                src={references}
                alt=""
                style={location.pathname === "/references" ? hide:show}
              />
                  References
                </Link>
              </li>
            </ul>
          </div>

          <div className="mt-auto">
            <ul
              className="nav nav-pills flex-column mb-auto"
              style={{
                borderTop: "1px solid #434343",
                borderBottom: "1px solid #434343",
                padding: "10px 0",
              }}
            >
              <li>
                <Link
                  to="/settings"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/settings" ? "active-custom" : ""
                  }`}
                >
                  <img
                src={settingDark}
                alt=""
                style={location.pathname === "/settings" ? show:hide}
              />
              <img
                src={setting}
                alt=""
                style={location.pathname === "/settings" ? hide:show}
              />
                  Settings
                </Link>
              </li>
              <li
                onClick={handleLogout}
              >
                <Link
                  to="#"
                  className={`nav-link text-white d-flex align-items-center`}
                >
                  <img src={signout} alt="" />
                  Sign Out
                </Link>
              </li>
            </ul>
            <ul
              className="nav nav-pills flex-column mb-auto sub-text"
            >
              <li>
                <Link
                  to="/contact"
                  className="nav-link text-secondary"
                  style={{ padding: "6px 18px", marginTop: "18px" }}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/termsofuse"
                  className="nav-link text-secondary"
                  style={{ padding: "6px 18px" }}
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link
                  to="/privacypolicy"
                  className="nav-link text-secondary"
                  style={{ padding: "6px 18px", marginBottom: "28px" }}
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
